/* eslint-disable react-hooks/exhaustive-deps */
import './datepicker.css';
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { Waypoint } from 'react-waypoint';
import { LeftOutlined, RightOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { addDays, addWeeks, format, getDate, isBefore, isSameDay, subWeeks, startOfDay, startOfWeek } from 'date-fns';

const DatePicker = ({
  selectDate: initialDate,
  startDate,
  endDate,
  shouldScroll,
  getSelectedDay,
  isDisabledDate: checkDisabledDate,
}: any) => {const [selectedDate, setSelectedDate] = useState(initialDate);
  const todayDate = new Date();
  const [softSelect, setSoftSelect] = useState(initialDate || new Date());
  const [currentWeek, setCurrentWeek] = useState(startOfWeek(selectedDate || startDate || new Date(), { weekStartsOn: 1 }));
  const [currentDate] = useState(selectedDate || startDate || new Date());
  let maxValue = shouldScroll ? (endDate | 90) : 7;
  let selectDate = initialDate;
  const dateFormat = 'MMM yyyy';
  let dateContainer = document.getElementById('container') as any;
  const dateContainerWidth = dateContainer ? dateContainer.getBoundingClientRect().width : null;

  const getId = (day: any) => {
    return isSameDay(day, selectedDate) ? 'selected' : '';
  };

  const getStartDate = () => {
    return currentWeek;
  };

  const getStyles = (day: any) => {
    const classes = [] as any;
    const isSelectedDate = isSameDay(day, selectedDate);
    const isPastDate = isBefore(day, startOfDay(startDate));
    const isDisabledDate = checkDisabledDate && checkDisabledDate(day);

    if (isSelectedDate) {
      classes.push('DateDayItem--OptionSelected');
    }

    if (isPastDate || isDisabledDate) {
      classes.push('DateDayItem--OptionDisabled');
    }

    return classes.join(' ');
  };

  const getType = (day: any) => {
    const isCurrentDate = isSameDay(day, todayDate);
    const isSelectedDate = isSameDay(day, selectedDate);

    return (isCurrentDate || isSelectedDate) ? 'primary' : 'default';
  };

  const isGhostType = (day: any) => {
    const isCurrentDate = isSameDay(day, todayDate);
    const isSelectedDate = isSameDay(day, selectedDate);

    return !isSelectedDate && isCurrentDate;
  };

  const renderDays = () => {
    const dayFormat = "E";
    const dateFormat = "d";
    const days = [] as any;
    let startDay = getStartDate();

    for (let i = 0; i < maxValue; i++) {
      days.push(
        <Button
          className={`Datepicker--DateDayItem Datepicker--Option ${getStyles(addDays(startDay, i))}`}
          id={`${getId(addDays(startDay, i) as any)}`}
          ghost={isGhostType(addDays(startDay, i))}
          key={i * i + 2}
          onClick={() => onDateClick(addDays(startDay, i))}
          type={getType(addDays(startDay, i))}
        >
          {getDate(addDays(startDay, i)) === 1 ?
            <Waypoint horizontal={true} onEnter={() => (setSoftSelect(addDays(startDay, i)))}/> : null}
          {getDate(addDays(startDay, i)) === 20 ?
            <Waypoint horizontal={true} onEnter={() => (setSoftSelect(addDays(startDay, i)))}/> : null}
          {isSameDay(addDays(startDay, i), currentDate) ?
            <Waypoint horizontal={true} onEnter={() => (setSoftSelect(addDays(startDay, i)))}/> : null}
          <div className={"Datepicker--DayLabel"} key={i}>
            {format(addDays(startDay, i), dayFormat)}
          </div>
          <div className={"Datepicker--DateLabel"} key={i * i + 1}>
            {format(addDays(startDay, i), dateFormat)}
          </div>
        </Button>
      );
    }

    return (
      <React.Fragment>{days}</React.Fragment>
    );
  };

  const onDateClick = day => {
    if (!isBefore(day, startOfDay(startDate))) {
      selectDate = null;
      setSelectedDate(day);
      if (getSelectedDay) {
        getSelectedDay(day);
      }
    }
  };

  const nextWeek = () => {
    shouldScroll ? (document.getElementById('container') as any).scrollLeft += dateContainerWidth : setCurrentWeek(addWeeks(currentWeek, 1))
  };

  const prevWeek = () => {
    shouldScroll ? (document.getElementById('container') as any).scrollLeft -= dateContainerWidth : setCurrentWeek(subWeeks(currentWeek, 1))
  };

  const nextMonth = () => {
    shouldScroll ? (document.getElementById('container') as any).scrollLeft += dateContainerWidth : setCurrentWeek(addWeeks(currentWeek, 4))
  };

  const prevMonth = () => {
    shouldScroll ? (document.getElementById('container') as any).scrollLeft -= dateContainerWidth : setCurrentWeek(subWeeks(currentWeek, 4))
  };

  useEffect(() => {
    if (getSelectedDay && selectDate) {
      getSelectedDay(selectDate);
    }
  }, []);

  useEffect(() => {
    if (selectDate) {
      if (!isSameDay(selectedDate, selectDate)) {
        setSelectedDate(selectDate);
        setTimeout(() => {
          let view = document.getElementById('selected');
          if (view) {
            view.scrollIntoView({behavior: "smooth", inline: "center", block: "nearest"});
          }
        }, 20);
      }
    }
  }, [selectDate]);

  return (
    <div className="Datepicker--Container">
      <div className="Datepicker--Strip">
        <div className="Datepicker--MonthYearLabel">
          <Button
            icon={<DownOutlined />}
            title="Previous month"
            className="Datepicker--DateDayItem Datepicker--ButtonPrev"
            onClick={prevMonth}
            style={{
              border: 0,
              marginLeft: 30,
              marginRight: 30,
            }}
          />

          <span style={{
            display: 'inline-block',
            minWidth: 110,
          }}>
            {shouldScroll ? format(softSelect, dateFormat) : format(currentWeek, dateFormat)}
          </span>

          <Button
            icon={<UpOutlined />}
            title="Next month"
            className="Datepicker--DateDayItem Datepicker--ButtonNext"
            onClick={nextMonth}
            style={{
              border: 0,
              marginLeft: 30,
              marginRight: 30,
            }}
          />
        </div>

        <div className="Datepicker">
          <Button
            icon={<LeftOutlined />}
            title="Previous week"
            className="Datepicker--DateDayItem Datepicker--ButtonPrev"
            onClick={prevWeek}
          />

          <div id={"container"} className={shouldScroll ? 'Datepicker--DateList--scrollable' : 'Datepicker--DateList'}>
            {renderDays()}
          </div>

          <Button
            icon={<RightOutlined />}
            title="Next week"
            className="Datepicker--DateDayItem Datepicker--ButtonNext"
            onClick={nextWeek}
          />
        </div>
      </div>
    </div>
  );
}

export default DatePicker;
